export class ConsumpationData {

  public ItemCode: number;
  public Quantity: number;
  public ItemName: string;
  public Uom: string;
  public ItemCost: number;
  public Code: number;
  public Material: number;
  public MaterialGroup: number;
  public Supplier: number;
  public SupplierName: string;
  public MaterialBatchStorage: number;
  //public ItemCost: number;
  public ExpiryDate: Date;
  public SupplierBatchDetails: string;
  public Remarks: string;
  public GroupCode: number;
  public SupplierMaterialBatch: number;

  public GroupName: string;
  public GroupType: string;
  public MinQty: number;
  public MaxQty: number;
}

export class ItemDetails {
  public ItemName: string;
  public MinQty: number;
  public MaxQty: number;
  public Uom: string;
  public RowNumber: number;
  public GroupCode: number;
  public GroupName: string;
  public Edit: boolean;
}

